import Modal from './Modal';

class SimpleModal extends Modal {
  cbOnModalClose(): void {}
  cbOnModalOpen(): void {}
}

export default SimpleModal;
